<template>
  <div>
    <a
      :class="{
        'ticket-with-link': !isDisabled,
        'ticket--inactive': isDisabled,
        'ticket-giftee-asterisk': showableGifteeAsterisk
      }"
      :href="linkUrl"
    >
      <div class="ticket-box">
        <span v-if="isTicketExpired" class="tag">期限切れ</span>
        <span v-if="isTicketExchanged" class="tag">利用済み</span>
        <span class="ticket-image">
          <img v-lazy="imageUrl" />
        </span>
        <div class="ticket-info">
          <p class="ticket__brand--small">
            {{ brandName }}
          </p>
          <p class="ticket__item-name">
            {{ itemName }}
          </p>
          <p v-if="isNotEmptyItemSkuName" class="ticket__item-min-unit">
            {{ itemSkuName }}
          </p>
          <p
            v-if="!isDisabled && isNotEmptyExprirationDate"
            class="ticket-expired-date"
          >
            有効期限：{{ expirationDate }}まで
          </p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    // TODO: ↓名称をexpiredDateに変更する
    expirationDate: {
      type: String,
      required: false,
      default: ''
    },
    isTicketExpired: {
      type: Boolean,
      required: true
    },
    isTicketExchanged: {
      type: Boolean,
      required: true
    },
    showableGifteeAsterisk: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isNotEmptyExprirationDate() {
      return this.expirationDate !== ''
    },
    isNotEmptyItemSkuName() {
      return this.itemSkuName !== ''
    },
    isDisabled() {
      return this.isTicketExpired || this.isTicketExchanged
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket {
  font-size: 1.6rem;
  line-height: 1.6;
  color: $black;
  text-decoration: none;
  width: 100%;
  display: block;
  background-color: $white;
  border-radius: 8px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  &-box {
    height: 108px;
    box-sizing: border-box;
    padding: 8px;
    display: flex;
    gap: 13px;
    align-items: center;
  }

  &-image {
    height: 92px;
    width: 92px;
    font-size: 0;
  }

  &-image img {
    height: 100%;
    border-radius: 4px;
  }

  &-info {
    overflow: hidden;
    width: 100%;
  }

  &__item-name {
    @extend %subhead-bold;
    white-space: normal;
    overflow-wrap: break-word;
    font-size: 1.2rem;
    max-height: calc(1.2rem * 1.6 * 2);
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  &__item-min-unit {
    @extend %body-bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.2rem;
  }

  &__brand--small {
    @extend %minimal;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &-expired-date {
    @extend %caption-bold;
    margin-top: 2px;
    text-align: left;
    color: $primary;
  }

  &-giftee-asterisk {
    @include bg-settings(
      '../../../../../images/giftee-asterisk.svg',
      $white,
      35px,
      35px
    );
    background-position: top right;
  }
}

.ticket-with-link {
  @extend .ticket;
  @extend %hover-common;
  cursor: pointer;
}

.ticket--inactive {
  @extend .ticket;
  @extend %hover-common;
  pointer-events: auto;
  position: relative;
  box-shadow: none;

  .ticket-box::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: $gray-2;
    opacity: 0.8;
    border-radius: 8px;
  }

  .ticket-box {
    position: relative;

    .tag {
      z-index: 1;
      position: absolute;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 8px 16px;
      height: 34px;
    }
  }
}
</style>
